import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button, Flex, Text } from '@chakra-ui/react';
import {
  NOTIFICATION_TYPE_TOPIC_MAP,
  SUBSCRIPTION_STATUS_TYPE,
} from '../../../../../constants/benchat';
import useGeneralSubscription from '../../../../../hooks/useGeneralSubscription';
import pnotifyService from '../../../../../service/pnotifyService';
import { CheckCircle } from '../../../../context/Chakra/Icons';
import { useAppContext } from '../../../context/appContext';

const GeneralSubscription = (props) => {
  const {
    e2eId,
    title,
    notificationType,
    shouldCheckMemberReward,
    ...restProps
  } = props;
  const { t } = useTranslation();
  const { currentUser } = useAppContext();
  const { hasSubscribed, subscribe, unsubscribe, checkMemberReward } =
    useGeneralSubscription({
      userId: currentUser._id,
      topics: NOTIFICATION_TYPE_TOPIC_MAP[notificationType],
      ...restProps,
    });
  const handleSubscribe = async () => {
    const result = await subscribe();
    switch (result) {
      case SUBSCRIPTION_STATUS_TYPE.SUCCESS:
        if (shouldCheckMemberReward) checkMemberReward(currentUser._id);
        pnotifyService.notify(t('member_profile.subscribe.successfully'));
        break;
      case SUBSCRIPTION_STATUS_TYPE.USER_WITHOUT_MOBILE_ERROR:
        pnotifyService.notify(t('member_profile.sms.subscribe.error'), {
          customClass: 'error',
          icon: 'fa fa-exclamation-triangle',
        });
        break;
      default:
        pnotifyService.notify(t('member_profile.subscribe.error'), {
          customClass: 'error',
          icon: 'fa fa-exclamation-triangle',
        });
    }
  };

  const handleUnsubscribe = async () => {
    const result = await unsubscribe();
    if (result === SUBSCRIPTION_STATUS_TYPE.SUCCESS) {
      pnotifyService.notify(t('member_profile.unsubscribe.successfully'));
    } else {
      pnotifyService.notify(t('member_profile.unsubscribe.error'), {
        customClass: 'error',
        icon: 'fa fa-exclamation-triangle',
      });
    }
  };

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Text
        variant="formLabel"
        className="member-center-profile__label"
        textAlign="left"
      >
        {title}
      </Text>
      <Button
        type="button"
        variant="outline"
        onClick={hasSubscribed ? handleUnsubscribe : handleSubscribe}
        data-e2e-id={e2eId}
        className={classNames(
          'member-center-profile__outline-button',
          hasSubscribed
            ? 'general-unsubscribe-button'
            : 'general-subscribe-button',
        )}
      >
        {hasSubscribed ? (
          <>
            <CheckCircle />
            <Text variant="subscribeText">
              {t('member_profile.subscribed')}
            </Text>
          </>
        ) : (
          <Text variant="subscribeText">{t('member_profile.subscribe')}</Text>
        )}
      </Button>
    </Flex>
  );
};

GeneralSubscription.propTypes = {
  title: PropTypes.string.isRequired,
  subscriptions: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }),
  ),
  platform: PropTypes.string.isRequired,
  notificationType: PropTypes.string.isRequired,
  e2eId: PropTypes.string,
  shouldCheckMemberReward: PropTypes.bool,
};

export default GeneralSubscription;
